import React from "react";
import "./SoftwareSystemAndDevelopment.css";

const SoftwareSystemAndDevelopment = () => {
  return (
    <div>
      <p>This is SoftwareSystemAndDevelopment section</p>
      <p>This is SoftwareSystemAndDevelopment section</p>
      <p>This is SoftwareSystemAndDevelopment section</p>
      <p>This is SoftwareSystemAndDevelopment section</p>
      <p>This is SoftwareSystemAndDevelopment section</p>
      <p>This is SoftwareSystemAndDevelopment section</p>
      <p>This is SoftwareSystemAndDevelopment section</p>
      <p>This is SoftwareSystemAndDevelopment section</p>
      <p>This is SoftwareSystemAndDevelopment section</p>
      <p>This is SoftwareSystemAndDevelopment section</p>
      <p>This is SoftwareSystemAndDevelopment section</p>
    </div>
  );
};

export default SoftwareSystemAndDevelopment;
